/* eslint-disable @typescript-eslint/no-unused-vars */

import { rebateOfferAssets } from "assets/cdn";
import { RebateConfig } from "contexts/WebStoreProvider/types";
import { useImagePath } from "hooks/useImagePath";
import { useRebateInfoPanelLogic } from "./hooks/useRebateInfoPanelLogic";
import {
	Circle,
	Container,
	EarnedText,
	ItemImage,
	RewardContainer,
	RewardItem,
	Span
} from "./styles";
import { formatDuration, highlight } from "../helpers";

interface Props {
	rebateConfig: RebateConfig;
}

const RebateInfoPanel = ({ rebateConfig }: Props) => {
	const { getImage } = useImagePath("cdn");
	const { rewardType } = useRebateInfoPanelLogic(rebateConfig);

	return (
		<Container>
			<Circle $backgroundImage={getImage(rebateOfferAssets.rewardCircle)}>
				<RewardContainer>
					<RewardItem>
						<ItemImage src={rewardType?.imageUrl} alt="" />
					</RewardItem>
				</RewardContainer>
			</Circle>
			<EarnedText>
				<Span>
					{"Earn "}
					{highlight(rebateConfig?.rebateReturn)}{" "}
					{highlight(
						rebateConfig?.rebateReturn > 1
							? rewardType?.pluralLabel
							: rewardType?.singularLabel
					)}
					{" back for every "}
				</Span>
				<Span>
					{highlight(`${rebateConfig?.targetSpend} used`)}
					{" for "}
					{highlight(formatDuration(rebateConfig?.durationMinutes))}
					{" from purchase!"}
				</Span>
			</EarnedText>
		</Container>
	);
};

export default RebateInfoPanel;
